export default "__VITE_ASSET__5be82a42__"